export const theme = {
  /* background: '#f5f8fb', */
  fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
  headerBgColor: '#112b53',
  headerFontColor: '#fff',
  headerFontSize: '21px',
  botBubbleColor: '#112b53',
  botFontColor: '#fff',
  userBubbleColor: '#fff',
  userFontColor: '#8f8e91',
};
